import { Plugin } from '@jeppesen-foreflight/jmkw-types';
import { LOCATION_BUTTON } from './location.button';
import { LOCATION_LAYER } from './location.layer';

export const LOCATION_PLUGIN = new Plugin({
  id: 'location',
  button: LOCATION_BUTTON,
  layer: LOCATION_LAYER
});
